var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.servicesInitialized)?_c('InitializingMessage'):_c('v-container',{staticClass:"service-container d-flex flex-column px-12 pt-12"},[_c('ServiceHeader',{staticClass:"d-flex flex-column",attrs:{"service":_vm.getServiceById(_vm.$route.params.id)}}),_c('router-view')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }